const { baseBUCGet } = require('../base/baseBUC');

const str = '';
//const int = 0;
const dateTimeStr = new Date()?.toISOString();

const reserveCommonAreaModelGet = ({ buildingId = '', apartmentId = '', commonAreaId = '', userId = '', }) => {
    return {
        apartmentId: apartmentId,
        commonAreaId: commonAreaId,
        comment: str,
        dateFrom: dateTimeStr,
        dateTo: dateTimeStr,
        status: -1,
        statusComment: str,
        statusDate: dateTimeStr,
        statusUserId: str,
        ...baseBUCGet({ buildingId: buildingId, userId: userId, }),
    }
};

module.exports = {
    reserveCommonAreaModelGet,
}